import React from "react";
import "./Footer.scss";

const Footer = () => {
	return (
		<main>
			<footer>
				<div className="has-text-centered">
					<p className="copyright-text">
						<p class="logo-custom-small">
							Made with React, as love alone can't make websites!
						</p>
					</p>
				</div>
			</footer>
		</main>
	);
};

export default Footer;
